import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDatepickerModule, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, formatDate } from '@angular/common';
import { InitiateModel } from '../ad-interface/initiate.model';
import { AdService } from '../ad-service/ad-service';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { SnackbarService } from '../../../shared/services/snackbar/snackbar.service';
import { HttpStatusCode } from 'axios';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-ad-initiate',
  providers: [provideMomentDateAdapter(MY_FORMATS)],
  imports: [
    MatDatepickerModule,
    MatDatepickerToggle,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatError,
    MatIconModule,
    ReactiveFormsModule,
    CommonModule

  ],
  templateUrl: './ad-initiate.dialog.html',
  styleUrl: './ad-initiate.dialog.scss'
})
export class AdInitiateDialog {
  private fb = inject(FormBuilder);
  private declarationService = inject(AdService);
  private dialogRef = inject(MatDialogRef<AdInitiateDialog>);
  private snackmessage = inject(SnackbarService)


  public years: number[] = [];

  public initiateForm: FormGroup = this.fb.group({

    year: ['', Validators.required],

    startDate: ['', Validators.required],

    endDate: ['', Validators.required]

  });

  constructor() {

    const currentYear = new Date().getFullYear();

    for (let i = currentYear; i >= currentYear - 10; i--) {

      this.years.push(i);

    }

  }

  public async initiate(): Promise<void> {
    if (this.initiateForm.invalid) {
      this.initiateForm.markAllAsTouched();
      return;
    }

    // 3. Map form values to match the InitiateModel interface (lowercase 'startdate' and 'enddate')
    const formRawValue = this.initiateForm.value;
    const startdate = formatDate(
      this.initiateForm.get('startDate')?.value,
      'yyyy-MM-dd',
      'en-US'
    );
    const enddate = formatDate(
      this.initiateForm.get('endDate')?.value,
      'yyyy-MM-dd',
      'en-US'
    );
    const payload: InitiateModel = {
      adYear: this.initiateForm.get('year')?.value, // Ensuring it is a string as per your interface
      adStartDate: startdate + 'T00:00:00Z',
      adEndDate: enddate + 'T00:00:00Z'
    };


    const response = await this.declarationService.initiatedeclaration(payload)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    if (response.status === HttpStatusCode.Ok) {
      this.dialogRef.close({ success: true, data: response });
      this.snackmessage.openSuccessSnackBar("Annual Declaration Initiated successfully!");

      // this.router.navigate(['/agent-onboarding']);

    } else {
      if (response.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackmessage.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (response.code === HttpStatusCode.Unauthorized) {
        this.snackmessage.openFailureSnackBar("Session timed out. Try logging in again!");

      }
    }

  }

  public closeDialog(): void {

    this.dialogRef.close();

  }

}
